module.exports = __webpack_public_path__ + "static/media/FFEP_230815.42d35fbf.jpg";